/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { DepotContainerBookingTO } from '../models/DepotContainerBookingTO';
import { HttpFile } from '../http/http';

export class TourTO {
    'tourId'?: number;
    'containerBookings': Array<DepotContainerBookingTO>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "tourId",
            "baseName": "tourId",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "containerBookings",
            "baseName": "containerBookings",
            "type": "Array<DepotContainerBookingTO>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return TourTO.attributeTypeMap;
    }

    public constructor() {
    }
}

